!(function () {
  "use strict";
  var e,
    r = {
      5481: function (e, r, n) {
        new (n(2223).Z)(".product-slides .swiper", {
          freeMode: !0,
          slidesPerView: 2.8,
          spaceBetween: 20,
          breakpoints: { 640: { slidesPerView: 5.33 } },
        });
      },
    },
    n = {};
  function t(e) {
    var o = n[e];
    if (void 0 !== o) return o.exports;
    var i = (n[e] = { id: e, loaded: !1, exports: {} });
    return r[e].call(i.exports, i, i.exports, t), (i.loaded = !0), i.exports;
  }
  (t.m = r),
    (e = []),
    (t.O = function (r, n, o, i) {
      if (!n) {
        var u = 1 / 0;
        for (s = 0; s < e.length; s++) {
          (n = e[s][0]), (o = e[s][1]), (i = e[s][2]);
          for (var f = !0, c = 0; c < n.length; c++)
            (!1 & i || u >= i) &&
            Object.keys(t.O).every(function (e) {
              return t.O[e](n[c]);
            })
              ? n.splice(c--, 1)
              : ((f = !1), i < u && (u = i));
          if (f) {
            e.splice(s--, 1);
            var l = o();
            void 0 !== l && (r = l);
          }
        }
        return r;
      }
      i = i || 0;
      for (var s = e.length; s > 0 && e[s - 1][2] > i; s--) e[s] = e[s - 1];
      e[s] = [n, o, i];
    }),
    (t.d = function (e, r) {
      for (var n in r)
        t.o(r, n) &&
          !t.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: r[n] });
    }),
    (t.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }),
    (t.nmd = function (e) {
      return (e.paths = []), e.children || (e.children = []), e;
    }),
    (t.j = 381),
    (function () {
      var e = { 381: 0 };
      t.O.j = function (r) {
        return 0 === e[r];
      };
      var r = function (r, n) {
          var o,
            i,
            u = n[0],
            f = n[1],
            c = n[2],
            l = 0;
          if (
            u.some(function (r) {
              return 0 !== e[r];
            })
          ) {
            for (o in f) t.o(f, o) && (t.m[o] = f[o]);
            if (c) var s = c(t);
          }
          for (r && r(n); l < u.length; l++)
            (i = u[l]), t.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return t.O(s);
        },
        n = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      n.forEach(r.bind(null, 0)), (n.push = r.bind(null, n.push.bind(n)));
    })();
  var o = t.O(void 0, [216], function () {
    return t(5481);
  });
  o = t.O(o);
})();
